/**
 * Geographical hierarchy. Continents and countries.
 */
export class Geography {
  private static _values: Geography[] = [];
  private static _valuesHierarchy: Geography[] = [];
  private static _lookup: Map<string, Geography> = new Map();

  public static readonly DEFAULT: Geography;

  static fromId(id: string) {
    const geography = Geography._lookup.get(id);
    if (geography === undefined) {
      throw new Error('Not a valid Geography.id: ' + id);
    }
    return geography;
  }

  static valuesHierarchy(): Geography[] {
    return [...Geography._valuesHierarchy];
  }

  static values(): Geography[] {
    return [...Geography._values];
  }

  static size(): number {
    return Geography._values.length;
  }

  // ---

  public readonly id: string;
  public readonly label: string;
  public readonly isSelectable: boolean;

  public readonly level: number;
  protected readonly _children: Geography[];

  constructor(id: string, label: string, level = 1) {
    this.id = id;
    this.label = label;
    this.isSelectable = true;

    this.level = level;
    this._children = [];
    Geography._lookup.set(id, this);
  }

  hasChildren(): boolean {
    return this._children.length > 0;
  }

  children(): Geography[] {
    return [...this._children];
  }

  toJson() {
    return this.id;
  }

  toString(): string {
    return '<Geography: ' + this.id + ", label='" + this.label + "'>";
  }
}

/**
 * Parse the preloaded geography data into Geography instances.
 *
 * @param data The preloaded data
 */
export const configureGeographies = (data: any[]): void => {
  const parse = (data: any, level: number, parent?: Geography) => {
    data.forEach((item: any) => {
      const geography = new Geography(item.id, item.name, level);
      (Geography as any)._values.push(geography);
      if (level === 1) {
        (Geography as any)._valuesHierarchy.push(geography);
      }
      if (parent) {
        (parent as any)._children.push(geography);
      }
      if (item.children && item.children.length) {
        parse(item.children, level + 1, geography);
      }
    });
  };

  parse(data, 1);

  // Hack to set world
  (Geography as any).DEFAULT = Geography.fromId('default');
};
